<div class="ui-msg-custom align-items-center {{ usedTheme }}"
     [class.d-flex]="icon">
  <i class="ui-msg-custom-icon {{ icon }}"
     *ngIf="icon"></i>

  <div>
    <ng-content></ng-content>
  </div>
</div>
